import {nextTick, onBeforeUnmount, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import {LANG_RTL} from "@/i18n";

export function useSwiper() {
  window.addEventListener('resize', resizeEvent, {passive: true});
  onBeforeUnmount(() => {
    window.removeEventListener('resize', resizeEvent);
  });

  const isDesktop = ref(false);

  function resizeEvent(): void {
    isDesktop.value = window.matchMedia("screen and (min-width: 601px)").matches;
  }

  resizeEvent();

  const {locale} = useI18n();
  watch(locale, resetSwiper);
  const resettingSwiperInstance = ref(false);

  function resetSwiper(newLocale: string, previousLocale: string) {
    if (LANG_RTL.includes(newLocale) === LANG_RTL.includes(previousLocale)) {
      return;
    }
    resettingSwiperInstance.value = true;
    nextTick(() => {
      resettingSwiperInstance.value = false;
    });
  }

  return {
    isDesktop,
    resettingSwiperInstance,
  };
}
